import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { toast } from "sonner";

const ROLE_LABEL = { super_admin: "Super Admin", owner: "Pemilik Toko", cashier: "Kasir" };

export default function Profile() {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user.name || "");
  const [password, setPassword] = useState("");

  const save = async () => {
    try {
      const { data } = await api.put("/profile", { name, password: password || undefined });
      setUser({ ...user, ...data });
      setPassword("");
      toast.success("Profil diperbarui");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="space-y-5 max-w-lg" data-testid="profile-page">
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight">Profil Pengguna</h1>
        <p className="text-muted-foreground text-sm">Kelola informasi akun Anda.</p>
      </div>

      <Card className="p-6 border-slate-200 rounded-xl shadow-sm space-y-4">
        <div className="flex items-center gap-4 pb-4 border-b border-slate-100">
          <div className="w-16 h-16 rounded-full bg-primary/10 text-primary flex items-center justify-center font-bold text-2xl overflow-hidden">
            {user.picture ? <img src={user.picture} alt="" className="w-full h-full object-cover" /> : (user.name?.[0]?.toUpperCase() || "U")}
          </div>
          <div>
            <div className="font-heading font-bold text-lg">{user.name}</div>
            <div className="text-sm text-muted-foreground">{user.email}</div>
            <span className="inline-block mt-1 text-xs font-semibold bg-accent text-primary rounded-full px-2 py-0.5">{ROLE_LABEL[user.role]}</span>
          </div>
        </div>
        <div><Label>Nama</Label><Input value={name} onChange={(e) => setName(e.target.value)} className="mt-1 rounded-lg" data-testid="profile-name-input" /></div>
        <div><Label>Email</Label><Input value={user.email} disabled className="mt-1 rounded-lg bg-slate-50" /></div>
        {user.auth_provider === "password" && (
          <div><Label>Kata Sandi Baru (opsional)</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Kosongkan jika tidak diubah" className="mt-1 rounded-lg" data-testid="profile-password-input" /></div>
        )}
        <Button onClick={save} className="rounded-lg" data-testid="save-profile-btn">Simpan Perubahan</Button>
      </Card>
    </div>
  );
}
